import { makeStyles } from '@mui/styles';
import Typography from 'apollo-react/components/Typography';
import React from 'react';
import { useSelector } from 'react-redux';

import { useTranslation } from '../../../custom-hooks/useTranslation';
import { IMPORT_STEPS, STATUSES } from '../../constants/import.constants';
import { getImportProp } from '../../selectors/import.selectors';
import { getImportCountByStatusCode, getRecordTitle } from '../../utils/import.utils';
import InfoBlock from '../common/InfoBlock';

const useStyles = makeStyles({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    marginTop: 10,
  },
  infoHeader: { marginBottom: 10 },
  errorMessage: { color: 'red' },
  successMessage: { color: '#00c221' },
});

export const ImportInfo = ({ importStatuses, importKey, importStep }) => {
  const classes = useStyles();
  const translateString = useTranslation();

  const hasImportError = useSelector(getImportProp(importKey, 'hasImportError'));
  const errorMessage = useSelector(getImportProp(importKey, 'errorMessage'));

  const recordsWithErrorStatusCount = getImportCountByStatusCode(importStatuses, STATUSES.ERROR);
  const recordsWithCompletedStatusCount = getImportCountByStatusCode(
    importStatuses,
    STATUSES.COMPLETED
  );
  const completedTitle = getRecordTitle(recordsWithCompletedStatusCount);
  const errorTitle = getRecordTitle(recordsWithErrorStatusCount);

  return (
    <div className={classes.container}>
      {hasImportError ? (
        <InfoBlock type="warning">
          <Typography className={classes.errorMessage}>{translateString(errorMessage)}</Typography>
        </InfoBlock>
      ) : (
        <>
          {importStep === IMPORT_STEPS.UPLOAD_COMPLETED && (
            <InfoBlock type="default">
              <div>
                <Typography variant="title2" className={classes.infoHeader}>
                  {`${translateString('Import information')}:`}
                </Typography>

                <Typography>{`${translateString(
                  'Imports with Complete Status'
                )}: ${recordsWithCompletedStatusCount} ${translateString(
                  completedTitle
                )}`}</Typography>

                <Typography>{`${translateString(
                  'Imports with Fail Status'
                )}: ${recordsWithErrorStatusCount} ${translateString(errorTitle)}`}</Typography>

                <Typography className={classes.successMessage}>
                  {translateString(
                    'Import has been completed. Verify the status of each transaction.'
                  )}
                </Typography>
              </div>
            </InfoBlock>
          )}
          {importStep === IMPORT_STEPS.UPLOAD_FILE && (
            <InfoBlock type="default">
              {translateString(
                'Review the Application Component Name generated from the selected components in step one and verify the Action for Duplicate Item. Disable the checkbox for item(s) to be excluded from the import process. Click the Import button to start the import process.'
              )}
            </InfoBlock>
          )}
          {importStep === IMPORT_STEPS.INITIAL_STEP && (
            <InfoBlock type="default">
              {translateString(
                'Click the Browse button and select a compressed file (*.zip) containing the exported component(s).'
              )}
            </InfoBlock>
          )}
          {importStep === IMPORT_STEPS.FILE_PROCESSING && (
            <InfoBlock type="default">
              {translateString('Click on the Cancel button to terminate the process.')}
            </InfoBlock>
          )}
        </>
      )}
    </div>
  );
};
